<template>
  <div class="card-container">
    <common-el-form
      :model="model"
      :rules="rules"
      :submitData="submitData"
      @success="onSuccess"
      ref="commonElForm"
      :showButton="false"
      :inline="false"
      :SubmitButton="true"
      :preservation="isHaved"
      submit-btn-text="保存"
      failTitle="提交失败"
      loadingText="提交中..."
      :hideRequiredAsterisk="true"
      :submitService="submitService"
      @beforeSubmit="beforeSubmit"
      class="common-margin"
    >
      <!-- <el-form-item label="类别" prop="type">
        <el-select v-model="model.type" style="width: 200px">
          <el-option
            v-for="item in types"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <div style="display: flex">
        <div style="width: 250px">
          <el-form-item label="名称" prop="name">
            <el-input
              type="text"
              show-word-limit
              placeholder="请输入名称"
              v-model="model.name"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div style="width: 255px; margin-left: 20px">
          <el-form-item label="排序" prop="serialNumber">
            <el-input
              type="text"
              show-word-limit
              placeholder="请输入"
              v-model="model.serialNumber"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="地址">
        <el-input
          type="text"
          show-word-limit
          placeholder="请输入名称"
          v-model="model.url"
          disabled
          style="width: 700px"
        ></el-input>
      </el-form-item>
      <div style="width: 100%">
        <el-form-item label="上传文件" style="width: 200px" prop="file">
          <el-upload
            v-show="!isRun"
            class="upload-demo"
            drag
            ref="uploadFile"
            prop="file"
            :action="uploadUrl + '8880/tatVariousLink/upload'"
            name="file"
            :data="commonParams"
            :show-file-list="false"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :before-upload="handleBeforeUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <div
          class="flex-col vertical-center flow-center progressBox"
          v-show="isRun"
        >
          <p style="font-size: 20px" v-if="looktitle">
            视频正在上传,请不要关闭浏览器
          </p>
          <p style="font-size: 20px" v-else>视频上传成功。</p>
          <div
            class="flex-row vertical-center flow-center"
            style="
              width: 100%;
              height: 20px;
              font-size: 18px;
              margin: 10px 0px 10px 0px;
            "
          >
            上传进度：
            <p style="width: 400px">
              <!-- <el-progress
                width="100%"
                :text-inside="true"
                :stroke-width="20"
                :percentage="
                  parseInt(progressInfo.percent ? progressInfo.percent : 0)
                "
                status="success"
              ></el-progress> -->
              <el-progress
                :percentage="
                  parseInt(progressInfo.percent ? progressInfo.percent : 0)
                "
                :format="format"
              ></el-progress>
            </p>
          </div>
          <div
            class="flex-row vertical-center flow-center"
            style="font-size: 18px"
          >
            文件名称：
            <p style="margin-right: 20px">{{ fileInfo.name }}</p>
            文件大小：
            <p>
              <!-- {{ parseInt(progressInfo.percent ? progressInfo.percent : 0) }}% / -->
              {{
                Math.floor(
                  ((fileInfo.size ? fileInfo.size : 0) / 1024 / 1024) * 100
                ) / 100
              }}MB
            </p>
          </div>

          <el-button
            type="primary"
            class="button-size"
            @click="handleCancel"
            v-show="progressInfo.percent == 100 ? false : true"
            >取消</el-button
          >
        </div>
      </div>
      <el-form-item label="备注" style="width: 360px">
        <el-input
          maxlength="80"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
          placeholder="请输入备注"
          v-model="model.remark"
        ></el-input>
      </el-form-item>
      <p
        v-if="!isHaved"
        class="notice-text"
        style="margin-bottom: 20px; color: #ebb563; font-size: 20px"
      >
        注意：保存按钮在提示视频上传成功之后自动显示。
      </p>
    </common-el-form>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import APPService from "service/APPService";
import Server from "common/conf/Server";
import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "operationvideoupdate",
  data() {
    return {
      looktitle: true,
      uploadUrl: Server[process.env.NODE_ENV],
      progressInfo: {},
      fileInfo: {},
      model: {
        url: "",
        name: "",
        // type: "",
        remark: "",
        serialNumber: "",
      },
      // types: [],
      rules: {
        serialNumber: [
          {
            required: true,
            validator: Regs.inputvalue,
          },
        ],
      },
      isHaved: false,
      // needBeforeSubmit: true,
      isRun: false,
      stepActive: 1,
      pictureNumber: 1,
      shareId: "",
    };
  },
  components: {
    CommonElForm,
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        url: this.model.url,
        name: this.model.name,
        // type: this.model.type,
        remark: this.model.remark,
        serialNumber: this.model.serialNumber,
      };
      if (this.shareId) {
        params.id = this.shareId;
      }
      return params;
    },
    submitService() {
      return this.shareId
        ? APPService.operationvideoEdit
        : APPService.operationvideoAdd;
    },
    commonParams() {
      const params = {
        tatId: this.tatId,
      };
      return params;
    },

    ...mapGetters(["userId", "tatId"]),
  },
  mounted() {
    this.isHaved = JSON.parse(this.$route.params.isHaved);

    if (this.$route.params.item) {
      this.model = JSON.parse(this.$route.params.item);
      this.shareId = this.model.id;
    }
    // this.getTypeNames("素材类型", (res) => {
    //   this.types = res;
    // });
  },
  methods: {
    format(percentage) {
      return percentage === 100 ? "100%" : `${percentage}%`;
    },
    goBack() {
      this.isReloadPage(true);
      this.showSuccess("操作成功");
      this.$router.back();
    },
    beforeSubmit() {
      // this.needBeforeSubmit = false;
      this.$nextTick(() => {
        this.goBack();
      });
    },
    onSuccess(res) {
      if (!this.shareId) {
        this.shareId = res.contents;
      }

      // this.needBeforeSubmit = true;

      if (this.model.id) {
        this.goBack();
      } else {
        this.goBack();
      }
    },
    handleBeforeUpload(file) {
      // const limitSize = file.size != 0;
      const ext = file.name.split(".").pop();
      const fileType = file.type.split("/")[0];
      if (
        fileType !== "video" &&
        ext !== "mp4" &&
        ext !== "avi" &&
        ext !== "mov"
      ) {
        this.$message.error(`只能上传视频文件`);
        return false;
      } else {
        this.isRun = true;
        this.fileInfo = file;
        this.progressInfo = {};
        return true;
      }
    },
    handleProgress(event, file, fileList) {
      this.progressInfo = event;
    },
    handleRemove(file, fileList) {
      this.isRun = false;
    },
    handleSuccess(res, file, fileList) {
      if (
        "0000" != res.respCode ||
        (res.contents &&
          res.contents.optStatus &&
          "0000" != res.contents.optStatus)
      ) {
        this.handleCancel();
        if (!res.contents) {
          return this.showError(res.respMsg || res.respCode + ":未知错误");
        }
        return this.showError(
          res.contents.optMsg || res.contents.optStatus + ":未知错误"
        );
      } else {
        this.model.url = res.contents;
        this.looktitle = false;
        this.isHaved = true;
        this.showSuccess(res.respMsg);
      }
    },
    handleCancel() {
      this.$refs.uploadFile.abort(this.fileInfo);
      this.$refs.uploadFile.clearFiles();
      this.isRun = false;
      this.progressInfo = {};
      this.fileInfo = {};
    },
    ...mapActions({
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
.avatar-uploader {
  display: inline-block;
  vertical-align: top;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 230px;
  height: 400px;
  line-height: 400px;
  text-align: center;
}

.avatar {
  width: 230px;
  height: 400px;
  display: block;
}

.btn-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.5s linear;
}

.avatar:hover + .btn-bg {
  opacity: 1;
  transform: translateY(0%);
}

.el-button--text {
  color: #f5f5f5;
}

.el-button--text:hover {
  color: #079ade;
}

.el-alert-box {
  margin: 30px 0px 0 30px;
}

.el-alert--warning.is-light {
  padding: 15px 16px;
}

.el-icon-delete {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/OperationVideoUpdate.vue